import {BankExpenditures, BankIncomes, Modelation, ModelationConfig} from '@generated/models';
import {ofType, unionize, UnionOf} from 'unionize';
import {EditorModel} from '../editor.model';
import {EditorStatusInfo} from './editor.state';

export const EditorActions = unionize(
  {
    SetModelation: ofType<Modelation>(),
    UpdateModel: ofType<EditorModel & {isInvalid?: boolean}>(),
    SetStatusInfo: ofType<EditorStatusInfo>(),
    SetBankIncomes: ofType<BankIncomes[]>(),
    SetBankExpenditures: ofType<BankExpenditures[]>(),
    SetModelationConfig: ofType<ModelationConfig>(),
  },
  {tag: 'type', value: 'payload'},
);

export type EditorAction = UnionOf<typeof EditorActions>;
